import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/integration/react";

import App from "./App";
import LoginModel from "./Components/LoginModel/LoginModel";
import { LoginModalProvider } from "./App/LoginModalProvider";
import AxiosProvider from "./Features/Utils/AxiosProvider";
import { store, persistor } from "./Features/Utils/store";
import "./index.css";
import OfflineBanner from "./Pages/OfflineBanner";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
        <BrowserRouter>
          <AxiosProvider>
            <OfflineBanner />
            <LoginModalProvider>
              <App />
              <LoginModel />
            </LoginModalProvider>
          </AxiosProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);